import { render } from "./ScrollviewComponent.vue?vue&type=template&id=3e0e1392&ts=true"
import script from "./ScrollviewComponent.vue?vue&type=script&lang=ts"
export * from "./ScrollviewComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__